import React from 'react'
import { Footer, Header } from '../components'
import bigSVG from '../assets/images/header-bg-large.svg'
import smallSVG from '../assets/images/header-bg.svg'
import { Grid } from '@softwaredev_cegeka/stix-core'
import { Unauthorized } from '../components'
import './dashboard.scss'

class UnauthorizedView extends React.Component {
    render() {
        return (
            <div>
                <Header userData={this.props.userData} />
                <div className={'header-bg-container'}>
                    <div
                        style={{ backgroundImage: `url(${bigSVG})` }}
                        className={'header-big-svg'}
                    />
                    <div className={'header-small-svg'}>
                        <img src={smallSVG} alt={''} />
                    </div>
                </div>
                <Grid.Container className={'page-body'}>
                    <Unauthorized />
                </Grid.Container>
                <Footer />
            </div>
        )
    }
}

export default UnauthorizedView
